import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash-es';

import TextInput from '@ess/ui/Form/TextInput';
import FlexBox from '@ess/ui/FlexBox';

import { useReactBasket } from '@basket/hooks/useReactBasket';
import useBasketListFilters from '@basket/hooks/useBasketListFilters';
import { BasketPosition, BasketView } from '@basket/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { Filters } from '@basket/components/BasketList/Controls/Filters';
import {
  onApplyCustomEvent,
  onBasketListCustomEvent,
  onSearchCustomEvent, onSortByCustomEvent,
} from '@basket/components/BasketList/BasketList';
import BasketActions from '@basket/components/BasketActions';
import { Sort } from '@basket/components/BasketList/Controls/Sort';
import { BasketListActions } from '@basket/components/BasketList/Controls/BasketListActions';

const AutoSuggestBasketList = () => {
  const {
    basket,
    changeView,
  } = useReactBasket();

  const {
    basketListFilterValue,
    onNameChangeHandler,
  } = useBasketListFilters();

  const [sortBy, setSortBy] = useState<any>('-modifyTime');
  const inputRef = useRef<any>(null);
  const { t } = useTranslation();

  const onInputFocus = () => {
    changeView(BasketView.BasketList);
  };

  const onViewChange = (event: React.MouseEvent) => {
    event.stopPropagation();
    const view = basket.view === BasketView.Basket
      ? BasketView.BasketList
      : BasketView.Basket;
    if (view === BasketView.Basket) {
      onNameChangeHandler('');
    }
    changeView(view);
  };

  const onInputChangeHandler = (event: any) => {
    const value = event?.target?.value ?? '';
    onNameChangeHandler(value);
    window.dispatchEvent(new CustomEvent(onSearchCustomEvent, {
      detail: value,
    }));
  };

  const onApply = (params: any) => {
    window.dispatchEvent(new CustomEvent(onApplyCustomEvent, {
      detail: params,
    }));
  };

  const onSortByChangeHandler = (sortBy: string) => {
    setSortBy(sortBy);
    window.dispatchEvent(new CustomEvent(onSortByCustomEvent, {
      detail: sortBy,
    }));
  };

  const onBasketListActionChangeHandler = (action: string, data: any) => {
    window.dispatchEvent(new CustomEvent(onBasketListCustomEvent, {
      detail: {
        action,
        data,
      },
    }));
  };

  return (
    <FlexBox width="100%" flexGrow={1} alignItems="center">
      <FlexBox width="100%" maxWidth="480px" style={{ cursor: 'pointer !important' }}>
        <TextInput
          ref={inputRef}
          onEndIconClick={onViewChange}
          endIcon={(
            <FontAwesomeIcon
              icon={basket.view === BasketView.BasketList ? faChevronUp : faChevronDown}
            />
          )}
          value={basket.view === BasketView.BasketList ? basketListFilterValue?.filters?.name : basket?.current?.name}
          onChange={onInputChangeHandler}
          onFocus={onInputFocus}
          placeholder={t('lbl_search_basket')}
          style={{
            borderBottomRightRadius: basket.view === BasketView.BasketList ? '0px' : '5px',
            borderTopRightRadius: basket.view === BasketView.BasketList ? '0px' : '5px',
          }}
        />
      </FlexBox>
      {basket.view === BasketView.BasketList && (
        <Filters
          onApply={onApply}
          sortBy={sortBy}
          setSortBy={setSortBy}
        />
      )}
      <FlexBox
        paddingLeft="10px"
        ml="auto"
      >
        {basket.view === 'Basket' ? (
          <BasketActions
            basket={{
              id: basket.current.id,
              name: basket.current.name,
              description: basket.description,
              selectedItems: basket.selectedItems,
              blocked: basket.isBlocked,
            }}
          />
        )
          : (
            <FlexBox>
              {[BasketPosition.bottom, BasketPosition.top].includes(basket.position) && (
                <FlexBox
                  width="200px"
                  mr="10px"
                >
                  <Sort
                    sortBy={sortBy}
                    onChange={onSortByChangeHandler}
                  />
                </FlexBox>
              )}
              <FlexBox
                mt="2px"
              >
                <BasketListActions
                  selectedBaskets={basket.basketListControl.data}
                  onAction={onBasketListActionChangeHandler}
                />
              </FlexBox>
            </FlexBox>
          )}
      </FlexBox>
    </FlexBox>
  );
};
export default AutoSuggestBasketList;
